import { render } from "./update-news.vue?vue&type=template&id=bbc89e46&scoped=true"
import script from "./update-news.vue?vue&type=script&lang=js"
export * from "./update-news.vue?vue&type=script&lang=js"

import "./update-news.vue?vue&type=style&index=0&id=bbc89e46&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbc89e46"],['__file',"src/components/applications/admin/update/update-news.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bbc89e46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bbc89e46', __exports__)) {
    api.reload('bbc89e46', __exports__)
  }
  
  module.hot.accept("./update-news.vue?vue&type=template&id=bbc89e46&scoped=true", () => {
    api.rerender('bbc89e46', render)
  })

}


export default __exports__